import { db } from "./db.js";
import { ref } from "vue";

// ==================== CREATE ====================

function addTrademark(firmId, data) {
  const ref = db.collection(`firms/${firmId}/additions/tm-addition/trademarks`).doc(data.serialNumber);
  return ref.set(data);
}

// ==================== READ ====================

async function getTrademarks(firmId) {
  const trademarks = ref([]);
  await db
    .collection(`firms/${firmId}/additions/tm-addition/trademarks`)
    .get()
    .then((querySnapshot) => {
        trademarks.value = querySnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
  return trademarks;
}

function streamTrademarks(firmId, onSnap) {
  return db
    .collection(`firms/${firmId}/additions/tm-addition/trademarks`)
    .onSnapshot(onSnap, (error) => { console.log(error); });
}

async function getTrademark(firmId, serialNumber) {
  return db.doc(`firms/${firmId}/additions/tm-addition/trademarks/${serialNumber}`)
    .get()
    .then((trademark) => {
      return trademark.exists ? trademark.data() : null;
    });
}

// ==================== UPDATE ====================

function updateTrademark(firmId, serialNumber, data) {
  return db.doc(`firms/${firmId}/additions/tm-addition/trademarks/${serialNumber}`).update(data);
}

async function getLatestOfficeActionDoc(firmId, serialNumber) {
  const snapshot = await db.collection(`firms/${firmId}/additions/tm-addition/trademarks/${serialNumber}/documents`).get();
  if (snapshot.empty) return null;

  const candidates = snapshot.docs
    .filter(d => d.id.startsWith("NFIN_") || d.id.startsWith("FREF_"))
    .sort((a, b) => b.id.localeCompare(a.id, undefined, { numeric: true }));

  if (!candidates.length) return null;

  const doc = candidates[0];
  const data = doc.data();
  const urls = data.urls || [];
  const oaUrl = urls.find(u => u.toLowerCase().includes("office-action")) || null;
  return {
    id: doc.id,
    url: oaUrl,
    originalFileName: data.originalFileName || "",
    ...data,
  };
}

export {
  addTrademark,
  getTrademarks,
  getTrademark,
  streamTrademarks,
  updateTrademark,
  getLatestOfficeActionDoc,
};
